import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';

export const PatientContext = createContext({});

export const Provider = (props) => {
  const {children} = props;

  const [selectedPatient, setSelectedPatient] = useState(null);
  const [reloading, setReloading] = useState(false);
  const [editing, setEditing] = useState(false);

  const patientContext = {
    selectedPatient,
    setSelectedPatient,
    reloading,
    setReloading,
    editing,
    setEditing,
  };

  return (
    <PatientContext.Provider value={patientContext}>
      {children}
    </PatientContext.Provider>
  );
};

export const {Consumer} = PatientContext;

Provider.propTypes = {
  children: PropTypes.any,
};
